import React from "react";
import Skill from "./Skill";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

const SKILLS = [
  "HTML",
  "CSS",
  "JavaScript",
  "React",
  "React Native",
  "Angular",
  "Flutter",
  "Node.js",
  "Express.js",
  "MongoDB",
  "Java",
  "Python",
  "Git",
  "Github",
  "Firebase",
  "Figma",
];
function About({ section }) {
  const [subtitle, subtitleInView] = useInView({
    triggerOnce: true, // Animation triggered only once
    threshold: 0.5, // Adjust the threshold as needed
  });
  const [title, titleInView] = useInView({
    triggerOnce: true, // Animation triggered only once
    threshold: 0.5, // Adjust the threshold as needed
  });

  const [skillsTitle, skillsTitleInView] = useInView({
    triggerOnce: true, // Animation triggered only once
    threshold: 0.5, // Adjust the threshold as needed
  });
  const animationVariants = {
    hidden: {
      opacity: 0,
      y: 50,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: "easeInOut",
      },
    },
  };
  return (
    <div className="about" ref={section}>
      <motion.div
        className="sub-title"
        ref={subtitle}
        initial="hidden"
        animate={subtitleInView ? "visible" : "hidden"}
        variants={animationVariants}
      >
        About me
      </motion.div>
      <motion.div
        className="title"
        ref={title}
        initial="hidden"
        animate={titleInView ? "visible" : "hidden"}
        variants={animationVariants}
      >
        Get to know me
      </motion.div>
      <div className="about-body">
        <motion.div
          initial="hidden"
          animate={titleInView ? "visible" : "hidden"}
          variants={animationVariants}
        >
          <div>
            I'm a versatile developer specializing in both{" "}
            <b> web and mobile development</b>. With expertise in frontend web
            development, I craft intuitive and visually appealing user
            interfaces for websites and web applications, driving the success of
            the overall product. Additionally, I have strong skills in{" "}
            <b>backend development</b>, which involve handling{" "}
            <b>server-side logic</b> and <b>database management</b>. I ensure
            seamless integration between the frontend and backend components,
            creating robust and scalable solutions. If you're interested in
            exploring some of my <b>showcased projects</b>, please check out the
            dedicated section .
          </div>
          <div style={{ marginTop: "20px" }}>
            I've accumulated a wealth of insights and experience in Web
            Development, and I am actively seeking new challenges and projects
            where I can leverage my versatile skill set in both web and mobile
            development. I am open to discussing potential job opportunities, so
            please feel free to reach out to me to explore how we can work
            together to achieve outstanding results.
          </div>
        </motion.div>
        <div>
          <motion.div
            className="about-title"
            ref={skillsTitle}
            initial="hidden"
            animate={skillsTitleInView ? "visible" : "hidden"}
            variants={animationVariants}
          >
            My skills
          </motion.div>
          <div className="skills">
            {SKILLS.map((item, index) => (
              <Skill key={index} index={index} name={item} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
